import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IconComponent, IconTypes } from '../icon/icon.component';
import { NgIf, NgTemplateOutlet } from '@angular/common';

export interface BtnClickEvent {
  stopSpinner(): void;
  startSpinner(): void;
}

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  imports: [IconComponent, NgIf, NgTemplateOutlet],
})
export class ButtonComponent {
  @Input() classNames = '';
  @Input() btnTitle = '';
  @Input() iconType: IconTypes | string = '';
  @Input() iconClasses = '';
  @Input() disabled = false;
  @Input() id: string | null = null;
  @Output() clickHandler = new EventEmitter();
  @ViewChild('btn') button?: ElementRef;
  iconClassesTmp = '';

  clickedButton(): void {
    if (this.disabled) return;

    this.clickHandler.emit({
      stopSpinner: () => {
        this.stopSpinner();
      },
      startSpinner: () => {
        this.startSpinner();
      },
    });
  }

  stopSpinner() {
    if (!this.button) return;

    this.button.nativeElement.idle();
    this.iconClasses = this.iconClassesTmp;
    this.iconClassesTmp = '';
  }

  startSpinner() {
    if (!this.button) return;

    this.iconClassesTmp = this.iconClasses;
    this.button.nativeElement.busy();
    this.iconClasses = '';
  }
}
